// IMPORTANT: THIS FILE IS AUTO GENERATED! DO NOT MANUALLY EDIT OR CHECKIN!
/* tslint:disable */
/* eslint-disable */
export const VERSION = {
    "dirty": true,
    "raw": "317122e-dirty",
    "hash": "317122e",
    "distance": null,
    "tag": null,
    "semver": null,
    "suffix": "317122e-dirty",
    "semverString": null,
    "version": "0.0.1"
};
/* tslint:enable */
